import { useCallback } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { getNumComparators } from "../../../library/comparators";

export const CustomPrefixFilter = (props) => {
	const { model, onModelChange, colDef } = props;
	const prefix = colDef.filterParams.prefix || "";
	const filterOptions = getNumComparators();

	const valueChanged = useCallback((event) => {
		if (event.target.value === "" || isNaN(event.target.value)) {
			onModelChange(null);
			return;
		}

		const newValue = Math.max(0, parseInt(event.target.value) || 0);
		const currentFilterType = model?.type || filterOptions[0]?.displayKey || "";
		onModelChange({ filter: newValue, type: currentFilterType });
	}, [onModelChange, model, filterOptions]);

	const filterChanged = useCallback((event) => {
		const newFilterType = event.target.value;
		const currentFilterValue = model?.filter;
		onModelChange({ filter: currentFilterValue ?? "", type: newFilterType });
	}, [onModelChange, model]);

	const clearFilter = useCallback(() => {
		onModelChange(null);
	}, [onModelChange]);

	return (
		<div className="state-filter">
			<Form>
				<Form.Select
					size="sm"
					value={model?.type ?? filterOptions[0]?.displayKey ?? ""}
					onChange={filterChanged}
				>
					{filterOptions.map((option, index) => (
							<option key={index} value={option.displayKey}>
							{option.displayName}
							</option>
					))}
				</Form.Select>

				<div className="id-filter">
					<span>{prefix}</span>
					<Form.Control
						size="sm"
						type="number"
						min={0}
						value={model?.filter ?? ""}
						onChange={valueChanged}
						onKeyDown={(e) => {
							if (["e", "E", ".", ","].includes(e.key)) {
								e.preventDefault();
							}
						}}
						placeholder="Job Id..."
					/>
				</div>

				<div className="d-flex justify-content-end mt-2 mb-2">
					<Button
						className="ag-button ag-standard-button ag-filter-apply-panel-button"
						size="sm"
						onClick={clearFilter}
					>
						Reset
					</Button>
				</div>
			</Form>
		</div>
	);
};
